import { gql } from '@apollo/client';

export const GET_SHOPIFY_PERMISSION_STATUS = gql`
  query GetShopifyPermissionStatus {
    getShopifyPermissionStatus {
      status
      message
      requiresReapproval
      stores {
        storeId
        storeDomain
        requiresReapproval
        requiredScopes
      }
    }
  }
`;
